import { render, staticRenderFns } from "./OPDetailTransationDetail.vue?vue&type=template&id=65e42bd1&"
import script from "./OPDetailTransationDetail.vue?vue&type=script&lang=js&"
export * from "./OPDetailTransationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports